export default __webpack_public_path__ + "static/media/element_5.cdc51061.webp";